import React from 'react';
import ServiceCard from './ServiceCard';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const ServiceGrid = ({ 
  services, 
  onEdit, 
  onDelete, 
  onToggleStatus, 
  isLoading,
  searchTerm,
  onAdd
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)]?.map((_, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 elevation-1">
            <div className="animate-pulse">
              <div className="bg-muted rounded-lg h-32 mb-4"></div>
              <div className="h-4 bg-muted rounded mb-2"></div>
              <div className="h-3 bg-muted rounded w-3/4 mb-4"></div>
              <div className="h-3 bg-muted rounded w-1/2 mb-4"></div>
              <div className="flex justify-between">
                <div className="h-8 bg-muted rounded w-16"></div>
                <div className="h-8 bg-muted rounded w-20"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (services?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-12 text-center elevation-1">
        <div className="flex flex-col items-center space-y-4">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center">
            <Icon name="Package" size={32} className="text-muted-foreground" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              {searchTerm ? 'No services found' : 'No services yet'}
            </h3>
            <p className="text-muted-foreground mb-6">
              {searchTerm 
                ? `No services match "${searchTerm}". Try adjusting your search terms.`
                : 'Get started by adding your first car wash service to the catalog.'
              }
            </p>
          </div>
          {!searchTerm && (
            <Button
              iconName="Plus"
              iconPosition="left"
              iconSize={16}
              onClick={()=>onAdd()}
              className="rounded"
            >
              Add Your First Service
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Results Summary */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Grid3X3" size={16} />
          <span>
            {services?.length} service{services?.length !== 1 ? 's' : ''} 
            {searchTerm && ` matching "${searchTerm}"`}
          </span>
        </div>
        
        {/* <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="LayoutGrid"
            iconPosition="left"
            iconSize={14}
          >
            Grid View
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="List"
            iconPosition="left"
            iconSize={14}
          >
            List View
          </Button>
        </div> */}
      </div>
      {/* Service Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services?.map((service) => (
          <ServiceCard
            key={service?.id}
            service={service}
            onEdit={onEdit}
            onDelete={onDelete}
            onToggleStatus={onToggleStatus}
          />
        ))}
      </div>
      {/* Load More Button (if needed) */}
      {services?.length >= 12 && (
        <div className="flex justify-center pt-6">
          <Button
            variant="outline"
            iconName="ChevronDown"
            iconPosition="right"
            iconSize={16}
          >
            Load More Services
          </Button>
        </div>
      )}
    </div>
  );
};

export default ServiceGrid;